import React from 'react';
import { SortingState } from '@tanstack/react-table';
import { useSearchParams } from 'react-router-dom';

export function useDataViewController<TFilters extends Record<string, any> = Record<string, any>>(initial?: {
  page?: number;
  pageSize?: number;
  search?: string;
  filters?: TFilters;
  tab?: string;
  sorting?: SortingState;
  domain?: string;
}) {
  const [searchParams] = useSearchParams();
  const [domain, setDomain] = React.useState<string | null>(initial?.domain ?? searchParams.get('domain') ?? null);
  const [page, setPage] = React.useState(initial?.page ?? 1);
  const [pageSize, setPageSize] = React.useState(initial?.pageSize ?? 20);
  const [search, setSearch] = React.useState(initial?.search ?? '');
  const [filters, setFilters] = React.useState<TFilters>(initial?.filters ?? ({} as TFilters));
  const [tab, setTab] = React.useState<string | null>(initial?.tab ?? searchParams.get('tab') ?? null);
  const [sorting, setSorting] = React.useState<SortingState>(initial?.sorting ?? []);
  const [refreshKey, setRefreshKey] = React.useState(0);

  const refresh = React.useCallback(() => setRefreshKey(k => k + 1), []);

  React.useEffect(() => {
    setPage(1);
  }, [search, JSON.stringify(filters), tab, JSON.stringify(sorting), domain]);

  return {
    domain,
    page,
    pageSize,
    search,
    filters,
    tab,
    sorting,
    refreshKey,
    setDomain,
    setPage,
    setPageSize,
    setSearch,
    setFilters,
    setTab,
    setSorting,
    refresh,
  };
}
